module.exports = __webpack_public_path__ + "img/crown.0f37d713.svg";